import "./styles.scss"

import React, { Fragment, useState, useRef, useEffect } from "react"
import { Link } from "gatsby"
import { motion } from "framer-motion"

import Slider from "react-slick"
import clsx from "clsx"

import { useLocale } from "context/locale"

import RoundedWrapper from "components/RoundedWrapper"
import Button from "components/Button"
import Input from "components/Input"
import ShareList from "components/ShareList"
import ShareDropdown from "components/ShareDropdown"

import { fadeAnimation } from "utils"

import IcoSearch from "assets/icons/search.svg"
// import IcoSlickPrev from "assets/icons/slick-button-prev.svg"
// import IcoSlickNext from "assets/icons/slick-button-next.svg"

const sliderProps = {
  dots: false,
  arrows: false,
  infinite: false,
  variableWidth: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: false,
}

const Content = ({ data }) => {
  const { t } = useLocale()

  const isBrowser = typeof window !== "undefined"
  const location = isBrowser ? window.location.href : null
  const [featuredExist, setFeaturedExist] = useState(null)

  const [search, setSearch] = useState(false)
  const [category, setCategory] = useState(null)
  const [query, setQuery] = useState("")

  const inputRef = useRef(null)
  const sliderRef = useRef(null)

  const handleSearchMobile = () => {
    if (inputRef.current) {
      const value = inputRef.current.value

      setQuery(value)
    }
  }

  useEffect(() => {
    setFeaturedExist(
      data?.allWpPost?.nodes?.filter(item => item.acfPost.isFeatured === true)
    )
  }, [data?.allWpPost?.nodes])

  const posts = data.allWpPost.nodes
    .filter(item =>
      featuredExist?.length > 0 ? item.acfPost.isFeatured !== true : item
    )
    .slice(featuredExist?.length > 0 ? null : 1)

  const postsFiltered = posts
    .filter(
      item =>
        item.title.includes(query) || item.title.toLowerCase().includes(query)
    )
    .filter(item =>
      item.categories.nodes.some(
        item => category === null || item.slug === category
      )
    )

  const categories = data?.allWpCategory.nodes.filter(
    item =>
      item.posts.nodes.length > 0 &&
      item.name !== "Uncategorized" &&
      item.name !== "Bez kategorii"
  )

  return (
    <section className="blog-content">
      <RoundedWrapper className="blog-content__wrapper">
        {data?.allWpPost.nodes.length > 0 ? (
          data.allWpPost.nodes
            .filter(item =>
              featuredExist?.length > 0
                ? item.acfPost.isFeatured === true
                : item
            )
            .slice(featuredExist?.length > 0 ? null : 0, 1)
            ?.map((item, index) => {
              const uri = `${item?.language?.code === "PL" ? "/pl" : ""}/blog/${
                item.slug
              }`

              return (
                <div className="blog-content__tile-main" key={index}>
                  <div className="row">
                    <motion.div
                      className="col-xl-5 col-md-6"
                      {...fadeAnimation}
                    >
                      <Link
                        className="blog-content__tile-main-image"
                        style={{
                          backgroundImage: `url('${item?.featuredImage?.node?.localFile?.publicURL}')`,
                        }}
                        to={uri}
                      />
                    </motion.div>
                    <motion.div
                      className="col-md-6 offset-xl-1"
                      {...fadeAnimation}
                    >
                      <Link to={uri}>
                        <h2>{item.title}</h2>
                      </Link>
                      <div
                        dangerouslySetInnerHTML={{ __html: item?.excerpt }}
                      />
                      <div className="blog-content__tile-main-row">
                        <Button to={uri} className="button--small button--blue">
                          {t("Read more")}
                        </Button>

                        <ShareList
                          className="blog-content__social-list"
                          url={location}
                        />
                        <ShareDropdown
                          className="blog-content__social-dropdown"
                          url={location}
                        />
                      </div>
                    </motion.div>
                  </div>
                </div>
              )
            })
        ) : (
          <motion.h2 className="blog-content__empty" {...fadeAnimation}>
            {t("No posts to display")}
          </motion.h2>
        )}
      </RoundedWrapper>

      {data?.allWpPost.nodes.length > 0 ? (
        <div className="container">
          <motion.div className="blog-content__actions" {...fadeAnimation}>
            <div className="blog-content__categories d-none d-md-flex">
              {getCategories(categories, {
                uncategorizedLabel: t("All categories"),
                category,
                setCategory,
              })}
            </div>

            <Slider
              ref={sliderRef}
              className="blog-content__categories-slider slick-mobile-slider d-md-none"
              {...sliderProps}
            >
              {getCategories(categories, {
                className: "slick-mobile-item",
                uncategorizedLabel: t("All categories"),
                category,
                setCategory,
              })}
            </Slider>

            <div className="blog-content__search">
              <ButtonSearch
                t={t}
                onClick={() => setSearch(prevSearch => !prevSearch)}
              />
              <ButtonSearch t={t} onClick={handleSearchMobile} isMobile />

              <div
                className={clsx(
                  "blog-content__search-dropdown",
                  search && "blog-content__search-dropdown--open"
                )}
              >
                <Input
                  className="no-m d-none d-md-flex"
                  placeholder={t("Search...")}
                  value={query}
                  onChange={({ target: { value } }) => setQuery(value)}
                />
                <Input
                  className="no-m d-md-none"
                  inputRef={inputRef}
                  placeholder={t("Search...")}
                />
              </div>
            </div>
          </motion.div>
        </div>
      ) : null}

      {data?.allWpPost.nodes.length > 0 ? (
        <div className="blog-content__grid">
          {posts?.length > 0 ? (
            postsFiltered?.length > 0 ? (
              postsFiltered.map((item, index) => {
                const uri = `${
                  item?.language?.code === "PL" ? "/pl" : ""
                }/blog/${item.slug}`

                return (
                  <div className="blog-content__tile" key={index}>
                    <motion.div className="container" {...fadeAnimation}>
                      <div className="row">
                        <div className="col-xl-2 col-md-3">
                          <Link
                            className="blog-content__tile-image"
                            style={{
                              backgroundImage: `url('${item?.featuredImage?.node?.localFile?.publicURL}')`,
                            }}
                            to={uri}
                          />
                        </div>
                        <div className="col-md-4 offset-xl-1">
                          <Link to={uri}>
                            <h4>{item?.title}</h4>
                          </Link>
                        </div>
                        <div className="col-xl-4 col-md-5 offset-xl-1">
                          <div
                            dangerouslySetInnerHTML={{ __html: item?.excerpt }}
                          />
                          <Button
                            to={uri}
                            className="button--xsmall button--bordered-blue"
                          >
                            {t("Read more")}
                          </Button>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                )
              })
            ) : (
              <div className="container">
                <h2>No results found for: {query}</h2>
              </div>
            )
          ) : (
            <div className="container">
              <h2>{t("No posts to display")}</h2>
            </div>
          )}

          {/* <div className="container">
            <div className="blog-content__pagination">
              <div className="blog-content__pagination-dots">
                <span className="current" />
                <span />
                <span />
                <span />
              </div>
              <div className="blog-content__pagination-nav">
                <button>
                  <img src={IcoSlickPrev} alt="" />
                </button>
                <button>
                  <img src={IcoSlickNext} alt="" />
                </button>
              </div>
            </div>
          </div> */}
        </div>
      ) : null}
    </section>
  )
}

const ButtonSearch = ({ t, isMobile, onClick }) => {
  return (
    <button
      className={clsx(isMobile ? "d-md-none" : "d-none d-md-flex")}
      onClick={onClick}
    >
      <img src={IcoSearch} alt="" />
      {t("Search")}
    </button>
  )
}

const getCategories = (data, options) => {
  const { className, uncategorizedLabel, category, setCategory } = options

  const defaultCategory = { name: uncategorizedLabel ?? "Default", slug: null }
  const dataParsed = data ? [defaultCategory, ...data] : [defaultCategory]

  const Element = className ? "div" : Fragment

  return dataParsed.map((item, index) => (
    <Element key={index} {...(className ? { className } : {})}>
      <button
        className={clsx(
          "blog-content__categories-button",
          category === item.slug && "current"
        )}
        onClick={() => setCategory(item.slug)}
      >
        {item.name}
      </button>
    </Element>
  ))
}

export default Content
